import React, { type FC, useCallback, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { ToastContext, type ToastMessage} from './ToastContext';

type SnackbarToastProps = {
    children: React.ReactNode;
};

const SnackbarToast: FC<SnackbarToastProps> = ({ children }) => {
    const [toasts, setToasts] = useState<ToastMessage[]>([]);

    const addToast = useCallback((message: ToastMessage) => {
        // console.log(message.message);
        message.id = Math.floor(Math.random() * (99999));
        setToasts((prevToasts) => [...prevToasts, message]);
    }, []);

    const handleCloseSnackbar = useCallback((id: number) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, []);

    return (
        <ToastContext.Provider value={{ addToast }}>
            {children}
            {toasts.map((toast, index) => (
                <Snackbar key={index} open autoHideDuration={5000} onClose={() => handleCloseSnackbar(toast.id as number)}>
                    <Alert onClose={() => handleCloseSnackbar(toast.id as number)} severity={toast.type} style={{ width: '100%' }}>
                        {toast.message}
                    </Alert>
                </Snackbar>
            ))}
        </ToastContext.Provider>
    );
};

export default SnackbarToast;
